var base = window.base;
var base;
(base = window.Flux).Certifications || (base.Certifications = {});
window.base = base;